import React from 'react';
import PropTypes from 'prop-types';

import TextFieldBox from 'components/TextFieldBox';

const ListItem = ({ editing, value, onChange, textPlaceholder }) => {
  const input = { value, onChange };
  return <TextFieldBox input={input} editing={editing} textPlaceholder={textPlaceholder} />;
};

ListItem.propTypes = {
  editing: PropTypes.bool,
  value: PropTypes.string,
  onChange: PropTypes.func,
  textPlaceholder: PropTypes.string
};

export default ListItem;
